<template>
	<div class="select_lawyer">
		<sec-title Text="精选律师" :showmore='false' />
		<div class="between">
			<i class="el-icon-arrow-left arrow" style="font-size: 50px;" @click="$refs.swiper.prev()"></i>
			<el-carousel ref="swiper"position="none" arrow="never" :autoplay="false" indicator-position	='none' >
			    <el-carousel-item v-for="item in 4" :key="item">
			      <div class="innerimgs">
			      	<img src="../../../assets/contmodeldet/law_sample.png" v-for="item in 4">
			      </div>
			    </el-carousel-item>
			  </el-carousel>
			  <i class="el-icon-arrow-left arrow" style="transform: rotate(180deg) ;font-size: 50px;" @click="$refs.swiper.next()"></i>
		</div>
		<div class="content flex between">
			<img src="../../../assets/contmodeldet/law_sample.png" >
			<div class="text">
				<span>徐子成<span class="FontSize18">专职律师<span class="FontOrange">¥99</span>/22分钟 </span> </span>
				<p class="FontGray FontSize16 mt20">徐子成律师，嘉兴学院法学学士、文学学士，安徽金榜律师事务所专职律师，
				具有深厚的法学理论功底和丰富的法律事务经验，擅长侵权纠纷、机动车交通事故纠纷、工伤保险待遇纠纷、
				离婚、合同纠纷等案件，在公司法律顾问等方面有深入的研究深入的研究...</p>
				<span class="FontGray FontSize16">服务人数：1000    |    好评数：50</span>
			</div>
			<div class="btn">
				电话咨询
			</div>
		</div>
	</div>
</template>

<script>
	import secTitle from "../../home/components/secTitle";
	export default{
		components:{secTitle}
	}
</script>

<style lang="scss" scoped>
	.select_lawyer{
		width: 1200px;
		height: 680px;
		margin: 0 auto;
		padding: 50px 0;
		.el-carousel{
			width: 1088px;
			.innerimgs{
				width: 100%;
				height: 300px;
				display: flex;
				justify-content: space-between;
				img{
					width: 257px;
					height: 300px;
				}
				
			}
		}
		.content{
			padding:30px 55px;
			img{
				width: 164px;
				height: 176px;
				object-fit: cover;
				border-radius: 5px;
			}
			.text{
				width: 720px;
				height: 176px;
				font-size: 24px;
			}
			.btn{
				width: 120px;
				height: 40px;
				line-height: 40px;
				text-align: center;
				font-size: 18px;
				color:#0465EA ;
				border-radius: 40px;
				border: 1px solid #0465EA;
			}
		}
	}
	.arrow:hover{
		color:#0465EA ;
	}
</style>
